window.mo = function(){
    "use strict";

    let currentWorkCards = [];

    const hasClass = function(el, className){
        var cn = " " + el.className + " ";
        return cn.indexOf(" " + className + " ") > -1; 
    }

    const toggleClass = function(el, className, include){
        var cn = " " + el.className + " ";
        cn = cn.replaceAll(" " + className + " ", "").trim();
        if (include) cn += " " + className;
        el.className = cn;
    }

    const openmenu = function(){
        if (window.menuopen){
            window.menuopen = false;
            toggleClass(document.body, "shownav", false);
            return false;
        }
        
        window.menuopen = true;
        toggleClass(document.body, "shownav", true);
        window.scrollTo(0,0);
        return false;
    };

    const homeimagelinklist = function (parentSelector){
        "use strict"
        const parent = document.querySelector(parentSelector);
        const target = parent.querySelectorAll('li');
        const opacity = 0.75;
        const bgs = [];
    
        target.forEach(function(el){
            let bg = el.querySelector(".bg");
            if (bg) bgs.push(bg);
    
            let a = el.querySelector("a");
            a.innerHTML = a.innerHTML.split("|")[0];
        });
    
        if (bgs.length > 1){
            for(var i=0; i<bgs.length; i++){
                let bg = bgs[i];
                bg.style.opacity = i==0? opacity : 0;
            }
            let currentBg = 0;
    
            setInterval(function(){
                bgs[currentBg].style.opacity = 0;
                currentBg++;
                if(currentBg >= bgs.length) currentBg = 0;
                bgs[currentBg].style.opacity = opacity;
            },5000);
        }
    };

    const postsplitheading = function (titleSelector, subtitleSelector){
        "use strict"
    
        let head = document.querySelector(titleSelector);
        let subhead = document.querySelector(subtitleSelector);
        
        let headParts = head.innerHTML.split("|");
        
        head.innerHTML = headParts.shift();
        if(headParts.length < 1){
            subhead.remove();
            return;
        }
        subhead.innerHTML = headParts.join("<br/>");
    };

    const tagsremoveartist = function (listSelector){
        "use strict"
    
        let list = document.querySelector(listSelector);
        let a = list.querySelectorAll("a");
    
        a.forEach(function(el){
            el.innerHTML = el.innerHTML.replace("Artist ", "");
        });
    };

    const pageresizeiframe = function (){
        let embeds = document.querySelectorAll(".kg-embed-card iframe");
        embeds.forEach(function(el){
            let w = el.getAttribute("width");
            let h = el.getAttribute("height");
    
            if (w && h){
                el.removeAttribute("width");
                el.removeAttribute("height");
                el.style.aspectRatio = w + "/" + h;
                if (w > h){
                    el.style.width = "100%";
                }else{
                    el.style.height = "60rem";
                }
            }
    
            let newdiv = document.createElement("div");
            newdiv.className = "iframeborder"
            el.parentElement.insertBefore(newdiv, el);
            newdiv.appendChild(el);
        });
    };

    const getworkcarddata = function (element, order){
        "use strict"
        return {
            image: element.getAttribute("data-image"),
            imagealt: element.getAttribute("data-imagealt"),
            url: element.getAttribute("data-url"),
            title: element.getAttribute("data-title"),
            tags: element.getAttribute("data-tags").trim().split(" "),
            tagsMatch: 0,
            filtered: false,
            order: order,
        }
    };

    const relatedwork = function (tagsSelector, relatedSelector){
        "use strict"
    
        let tagsParent = document.querySelector(tagsSelector);
        let tagsEls = tagsParent.querySelectorAll(".tag");
        let relatedParent = document.querySelector(relatedSelector);
        let relatedEls = relatedParent.querySelectorAll(".worklist");
    
        let related = [];
        for (var i=0; i< relatedEls.length; i++){
            let el = relatedEls[i];
            related.push(getworkcarddata(el, i));
        }
    
        tagsEls.forEach(function(el){
            let tag = el.getAttribute("data-tag");
            related.forEach(function(r){
                if(r.tags.includes(tag)){
                    let tagvalue = tag.indexOf("artist-") == 0 ? 3 : 1;
                    r.tagsMatch+=tagvalue;
                }
            });
        });
    
        related.sort(function(a, b) {
            if (a.tagsMatch == b.tagsMatch) return a.order - b.order;
            return b.tagsMatch - a.tagsMatch;
        });
    
        let output = [];
        for (var i=0; i<related.length && i<6; i++){
            let r = related[i];
            output.push(generatecardcontent(i, r))
        };
    
        relatedParent.innerHTML = output.join("");
        relatedParent.className = "workcards noimages";
    };

    const workcards = function (containerSelector){
        "use strict"
    
        let container = document.querySelector(containerSelector);
        let cardEls = container.querySelectorAll(".workcard");
    
        let cards = [];
        for (var i=0; i< cardEls.length; i++){
            let el = cardEls[i];
            cards.push(getworkcarddata(el, i));
        }
    
        currentWorkCards = cards;
        
        let output = [];
        cards.forEach(function(c){
            output.push(generatecardcontent(c.order, c))
        });
        container.innerHTML = output.join("");
        container.className = "workcards noimages";
    }

    const generatecardcontent = function (order, card){
        "use strict"

        let title = card.title.split("|");
        if (title.length > 2) title.length = 2;

        return "<article class='workcard' id='w"+order+"' data-match='"+card.tagsMatch+"' " + (card.image?"style='background-image:url("+card.image+")'":"") + ">"
            + "<a href='"+card.url+"'><span>"
            + "<img src='"+card.image+"' alt='"+card.imagealt+"' /> "
            + "<span>" + title.join("</span><br/><span>") + "</span>"
            + "</span></a>"
            + "</article>"
    };

    const tagfilter = function (tagsSelector, artistsSelector){
        "use strict"
        let tagsContainer = document.querySelector(tagsSelector);
        let artistsContainer = document.querySelector(artistsSelector);
    
        let tags=[];
        let artists=[];
    
        let tagsEls = tagsContainer.querySelectorAll("li");
        tagsEls.forEach(function(el){
            let tag = el.getAttribute("data-tag");
            let name = el.getAttribute("data-name");
            if(tag.indexOf("artist-") == 0){
                artists.push({name: name.replace("Artist ", ""), tag: tag});
            }else{
                tags.push({name: name, tag: tag});
            };
        });
    
        let populate = function(taglist){
            output = [];
            taglist.forEach(function(t){
                output.push("<li><a href='#"+t.tag+"' onclick='return window.mo.filtertag(this)'>"+t.name+"</li>")
            });
            return output.join("");
        }
    
        tagsContainer.innerHTML = populate(tags);
        artistsContainer.innerHTML = populate(artists);
    };

    const tagfilterinit = function(tagsSelector, artistsSelector){
        let urlParts = location.href.split("#");
        if (urlParts.length < 2) return;

        let hash = urlParts[1];
        if (hash.indexOf("tag-") == 0){
            let tag = hash.substring(4);
            let isArtist = tag.indexOf("artist-") == 0;

            let container = document.querySelector(isArtist ? artistsSelector : tagsSelector);

            let openLink = container.querySelector("a.tvlink");
            togglevisible(openLink);

            let links = container.querySelectorAll("a");
            links.forEach(function(a){
                if(a.getAttribute("href") == "#" + tag){
                    filtertag(a);
                }
            })
        }
    };

    const filtertag = function (aEl, dontUpdateUrl){
        "use strict"
    
        let tag = aEl.href.split("#")[1];
        let alreadySelected = aEl.className == "selected";
    
        let selected = document.querySelectorAll(".tagfilter .selected");
        selected.forEach(function(el){
            el.className="";
        });
    
    
        let filter = null;
        if (!alreadySelected){
            aEl.className="selected";
            filter = tag;
        }

        if (!dontUpdateUrl){
            let tag = filter ? "#tag-" + filter : "#";
            history.pushState({}, "", tag);
        }
    
        currentWorkCards.forEach(function(card){
            let filterThisCard = filter && !card.tags.includes(filter);
    
            if (filterThisCard != card.filtered){
                card.filtered = filterThisCard;
                let cardEl = document.getElementById("w" + card.order);
                toggleClass(cardEl, "filtered", filterThisCard);
            }
        });
    
        return false;
    };

    const togglevisible = function (linkEl){
        let target = "#" + linkEl.href.split("#")[1];
        let tvEl = document.querySelector(target);
        toggleClass(tvEl, "open", !hasClass(tvEl, "open"));

        return false;
    };

    const shownbsp = function(){
        var main = document.querySelector("main");
        main.innerHTML = main.innerHTML.replaceAll("&nbsp;", "<span style='background:red; font-size:2em;'>&nbsp;&nbsp;&nbsp;</span>")
    };

    // window.mo.
    return {
        openmenu: openmenu,
        homeimagelinklist: homeimagelinklist,
        postsplitheading: postsplitheading,
        tagsremoveartist: tagsremoveartist,
        pageresizeiframe: pageresizeiframe,
        relatedwork: relatedwork,
        workcards: workcards,
        tagfilter: tagfilter,
        tagfilterinit: tagfilterinit,
        filtertag: filtertag,
        togglevisible: togglevisible,
        shownbsp: shownbsp
    }
}();
















